import SAJM_GLOBALS from "../constants";
import GlobalWPUser from "../models/WPUser";
import moment from "moment";

export class WordPressController{

    //Connect to WordPress
    async WPLogIn(){
        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({  
                        username: SAJM_GLOBALS.WP_USER,
                        password: SAJM_GLOBALS.WP_PASSWORD,
                 })
            };
            let url = SAJM_GLOBALS.WP_HOST+"/wp-json/jwt-auth/v1/token";
            const response = await fetch(url, requestOptions);
            
            return await response.json();

        }
        catch (error) {
            console.log("WordPressController.WPLogIn:"+error);
        }


        
    }


    /**
     * 
     * WP IS Token valid
     * 
     */
    async WPIsTokenValid(){
        try {
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json',
                           'Authorization':'Bearer '+GlobalWPUser.token },
            };
            let url = SAJM_GLOBALS.WP_HOST+"/wp-json/jwt-auth/v1/token/validate";
            const response = await fetch(url, requestOptions);
            
            return await response.json();

        }
        catch (error) {
            console.log("WPIsTokenValid"+error);
        }
    }


    forcetoUTCDate(date){
        let offset = date.getTimezoneOffset();
        let ms = offset * 60 *1000
        let out = new Date(date.getTime()-ms)

        return out;
    }


    /**
     * 
     * WP CALENDAR EVENT CREATE
     * 
     */

    async WPCalendarEventCreate(title, start_date, end_date, publish_date, description, allDay, venueID){
        
        let opts = {};
        
        //set to UTC
        start_date = this.forcetoUTCDate(start_date);
        end_date = this.forcetoUTCDate(end_date);
        publish_date = this.forcetoUTCDate(publish_date);
        

        if (venueID !== null){
            opts = { 
                title: title,
                start_date: start_date,
                end_date: end_date,
                date: publish_date, // {String} La date de publication de l’évènement
                description: description, // {String} La description de l’évènement
                all_day: allDay, // {Boolean} Si les évènements sont sur toute la journée ou non
                venue: {id: venueID}, // {array[Integer]} L’ID ou les données du lieu d’évènement
            };
        }else{
            opts = { 
                title: title,
                start_date: start_date,
                end_date: end_date,
                date: publish_date, // {String} La date de publication de l’évènement
                description: description, // {String} La description de l’évènement
                all_day: allDay, // {Boolean} Si les évènements sont sur toute la journée ou non
            };
        }
        

        const requestOptions = {
            method: 'POST',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
            body: JSON.stringify(opts),
        };

        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/events';
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPCalendarEventCreate:"+error);
        }


    }

    /**
     * 
     * WP CALENDAR EVENT UPDATE
     * 
     */

     async WPCalendarEventUpdate(id, title, start_date, end_date, publish_date, description, allDay, venueID){
        
        let opts = {};
        
        //set to UTC
        start_date = this.forcetoUTCDate(start_date);
        end_date = this.forcetoUTCDate(end_date);
        publish_date = this.forcetoUTCDate(publish_date);

        if (venueID !== null){
            opts = { 
                title: title,
                start_date: start_date,
                end_date: end_date,
                date: publish_date, // {String} La date de publication de l’évènement
                description: description, // {String} La description de l’évènement
                all_day: allDay, // {Boolean} Si les évènements sont sur toute la journée ou non
                venue: {id: venueID}, // {array[Integer]} L’ID ou les données du lieu d’évènement
            };
        }else{
            opts = { 
                title: title,
                start_date: start_date,
                end_date: end_date,
                date: publish_date, // {String} La date de publication de l’évènement
                description: description, // {String} La description de l’évènement
                all_day: allDay, // {Boolean} Si les évènements sont sur toute la journée ou non
            };
        }
        

        const requestOptions = {
            method: 'POST',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
            body: JSON.stringify(opts),
        };

        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/events/'+id;
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPCalendarEventUpdate:"+error);
        }


    }

    /**
     * 
     * WP CALENDAR GET LIST
     * 
     */
    async WPGetCalendarEvent(){
        const requestOptions = {
            method: 'GET',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
        };

        let time = moment().format("h:m:s"); //api has to change each time to avoid error callback (undefined)
        
        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/events?start_date=2021-01-03 '+time+'&per_page=50';
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPGetCalendarEvent:"+error);
        }
    }


    /**
    * 
    * WP CALENDAR GET CALENDAR BY ID
    * 
    */
     async WPGetCalendarEventByID(id){
        const requestOptions = {
            method: 'GET',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
        };

        let time = moment().format("h:m:s"); //api has to change each time to avoid error callback (undefined)
        
        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/events/'+id+'?start_date=2021-01-03 '+time+'&per_page=50';
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPGetCalendarEventByID:"+error);
        }
    }


    /**
     * 
     * WP CALENDAR DELETE EVENT ID
     * 
     */
    async WPDeleteCalendarEvent(id){
        
        try {
            
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json',
                            'Authorization':'Bearer '+GlobalWPUser.token }
                 
            };
            
            let url = SAJM_GLOBALS.WP_HOST+"/wp-json/tribe/events/v1/events/"+id;
            
            const response = await fetch(url, requestOptions);
           
            return await response.json();

        }
        catch (error) {
            console.log("WordPressController.WPDeleteCalendarEvent:"+error);
        }
    }


    /**
     * 
     * WP CALENDAR GET VENUES
     * 
     */

     async WPGetCalendarVenues(){
        const requestOptions = {
            method: 'GET',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
        };
        
        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/venues';
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPGetCalendarVenues:"+error);
        }
    }

    /**
     * 
     * WP CALENDAR GET LOCATION ID
     * 
     */
    async WPGetCalendarVenueByID(id){
    
        try {
            
            const requestOptions = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json',
                            'Authorization':'Bearer '+GlobalWPUser.token }
                    
            };
            
            let url = SAJM_GLOBALS.WP_HOST+"/wp-json/tribe/events/v1/venues/"+id;
            
            const response = await fetch(url, requestOptions);
            
            return await response.json();

        }
        catch (error) {
            console.log("WordPressController.WPGetCalendarVenueByID:"+error);
        }
    }

    /**
    * 
    * WP UPDATE CALENDAR VENUES
    * 
    */
     async WPUpdateCalendarVenue(id, venue, address, zip, city){

        let opts = { 
            venue: venue,
            address: address,
            zip: zip,
            city: city
        };

        const requestOptions = {
            method: 'POST',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
            body: JSON.stringify(opts),
        };

        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/venues/'+id;
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPUpdateCalendarVenue:"+error);
        }

     }



    /**
     * 
     * WP CALENDAR CREATE VENUE
     * 
     */

    async WPCreateCalendarVenue(venue, address, zip, city){
        let opts = { 
            venue: venue,
            address: address,
            zip: zip,
            city: city
        };

        const requestOptions = {
            method: 'POST',
            headers: {  'Content-Type': 'application/json',
                        'Authorization':'Bearer '+GlobalWPUser.token },
            body: JSON.stringify(opts),
        };

        try {
            let url = SAJM_GLOBALS.WP_HOST+'/wp-json/tribe/events/v1/venues';
            const response = await fetch(url, requestOptions);

            return await response.json();
        }
        catch(error){
            console.log("WordPressController.WPCreateCalendarVenue:"+error);
        }


    }

    /**
     * 
     * WP CALENDAR DELETE LOCATION ID
     * 
     */
     async WPDeleteCalendarVenue(id){
        
        try {
            
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json',
                            'Authorization':'Bearer '+GlobalWPUser.token }
                 
            };
            
            let url = SAJM_GLOBALS.WP_HOST+"/wp-json/tribe/events/v1/venues/"+id;
            
            const response = await fetch(url, requestOptions);
           
            return await response.json();

        }
        catch (error) {
            console.log("WordPressController.WPDeleteCalendarVenue:"+error);
        }
    }


    
}

export default WordPressController;